class AccordionItems {
    constructor () {
        const accordionTitles = document.querySelectorAll('.accordion-item__title');

        if (accordionTitles.length === 0) {
            return;
        }

        if (!('classList' in document.createElement('a'))) {
            console.warn('AccordionItems', ' ClassList is not supported in this browser');
            return;
        }

        Array.prototype.forEach.call(accordionTitles, (item) => {
            item.addEventListener('click', function () {
                const parent = this.parentElement;
                if (parent.classList.contains('accordion-item') === false) {
                    console.warn('AccordionItems', 'The parent element of .accordion-item__title is not .accordion-item. Exiting');
                    return;
                }
                parent.classList.toggle('active');
            });
        })
    }
}

export { AccordionItems }